// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"48605c93","916":"67e564d1"}[chunkId] + ".chunk.css";
};